import { EnumPersonaFisicaRequestDTORuolo } from '@framework/api-client/api/backoffice/schemas/enumPersonaFisicaRequestDTORuolo.ts';
import { type PersonaFisicaDTO } from '@framework/api-client/api/inquiries-compile/schemas/personaFisicaDTO.ts';
import { type DatiSessioneUtenteUtenteLoggato } from '@framework/api-client/api/users/schemas/datiSessioneUtenteUtenteLoggato.ts';

export class DossierPermissionLogic {
  static isTitolare(
    user: DatiSessioneUtenteUtenteLoggato | null | undefined,
    dossierSubjects: PersonaFisicaDTO[] | null | undefined,
  ) {
    if (!user?.codiceFiscale || !dossierSubjects) {
      return false;
    }
    // Check se il soggetto è il titolare (esiste nella lista dei soggetti, è indicato come titolare e non ha una data di fine)
    return dossierSubjects.some(
      subject =>
        subject.role === EnumPersonaFisicaRequestDTORuolo.TITOLARE &&
        !subject.end &&
        subject.codiceFiscale === user?.codiceFiscale,
    );
  }

  static isEditor(
    user: DatiSessioneUtenteUtenteLoggato | null | undefined,
    dossierSubjects: PersonaFisicaDTO[] | null | undefined,
  ) {
    if (!user?.codiceFiscale || !dossierSubjects) {
      return false;
    }
    // Check se il soggetto è un editor (esiste nella lista dei soggetti, è indicato come editor e non ha una data di fine)
    return dossierSubjects.some(
      subject =>
        subject.role === EnumPersonaFisicaRequestDTORuolo.EDITOR &&
        !subject.end &&
        subject.codiceFiscale === user?.codiceFiscale,
    );
  }

  static canEditPermissions(
    user: DatiSessioneUtenteUtenteLoggato | null | undefined,
    dossierSubjects: PersonaFisicaDTO[] | null | undefined,
  ) {
    return DossierPermissionLogic.isTitolare(user, dossierSubjects);
  }

  static canViewPermissions(
    user: DatiSessioneUtenteUtenteLoggato | null | undefined,
    dossierSubjects: PersonaFisicaDTO[] | null | undefined,
  ) {
    if (process.env.HIDE_DOSSIER_MODULE_VISIBILITY === 'true') {
      return false;
    }
    return (
      DossierPermissionLogic.isTitolare(user, dossierSubjects) ||
      DossierPermissionLogic.isEditor(user, dossierSubjects)
    );
  }
}
